import { useEffect, useState } from "react";
import MESSAGES from "../../../../common/data/constants/messages";
import { ICustomer } from "../../../../common/data/dtos/customer";
import Badge from "../../../../components/bootstrap/Badge";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from "../../../../components/bootstrap/Card";
import { MoreActions } from "../../../../components/extras/MoreActions";
import { showSuccess, showWarning } from "../../../../components/extras/Notifications";
import PaginationButtons, { dataPagination, PER_COUNT } from "../../../../components/PaginationButtons";
import customerService from "../../../../services/customer-service";
import LoadingPage from "../../loading/LoadingPage";
import { CustomerModal } from "./CustomerModal";

export const CommonCustomerList = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['10']);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isModalOpened, setIsModalOpened] = useState(false);

	const [customers, setCustomers] = useState<ICustomer[]>([]);
	const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | null>(null);

	useEffect(() => {
		fetchCustomers();
	}, []);

	const fetchCustomers = async () => {
		setIsLoading(true);

		const response = await customerService.getCustomers();

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		setCustomers(response.customers || []);
	};

	const toggleModal = (isVisible: boolean) => {
		setIsModalOpened(isVisible);
	};

	const handleAddClick = () => {
		toggleModal(true);
	};

	const onModalClose = () => {
		toggleModal(false);
		setSelectedCustomer(null);
	};

	const onAfterSubmit = async () => {
		await fetchCustomers();
		onModalClose();
	};

	const handleDeleteClick = async (customer: ICustomer) => {
		if (!customer.id) {
			showWarning(MESSAGES.ACTION.DELETE_ID_ERROR);
			return;
		}

		setIsLoading(true);

		const response = await customerService.deleteCustomer(customer.id);

		setIsLoading(false);

		if (response.error) {
			showWarning(response.error);
			return;
		}

		showSuccess(MESSAGES.ACTION.DELETED);
		await fetchCustomers();
	};

	const handleEditClick = (customer: ICustomer) => {
		setSelectedCustomer(customer);
		toggleModal(true);
	};

	if (isLoading) {
		return <LoadingPage />;
	}
	return (
		<>
			<Card style={{ minHeight: 600 }}>
				<CardHeader borderSize={1}>
					<CardLabel icon='AccountCircle' iconColor='primary'>
						<CardTitle tag='div' className='h5'>
							Clientes
						</CardTitle>
					</CardLabel>
					<CardActions>
						<Button color='light' icon='AddCircle' onClick={handleAddClick}>
							Adicionar
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody className='table-responsive'>
					<table className='table table-modern table-hover'>
						<thead>
							<tr>
								<th>Nome</th>
								<th>Situação</th>
								<td aria-labelledby='Actions' />
							</tr>
						</thead>
						<tbody>
							{dataPagination(customers, currentPage, perPage).map((item: ICustomer) => (
								<tr key={item.id}>
									<td>{item.name}</td>
									<td>
										{item.status ? (
											<h5>
												<Badge color='success' className='align-items-center justify-content-center'>
													Ativo
												</Badge>
											</h5>
										) : (
											<h5>
												<Badge color='danger' className='align-items-center justify-content-center'>
													Inativo
												</Badge>
											</h5>
										)}
									</td>

									<MoreActions id={item.id} showEdit={true} showDelete={true} onEditClick={() => handleEditClick(item)} onDeleteClick={() => handleDeleteClick(item)} />
								</tr>
							))}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons data={customers} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
			</Card>

			<CustomerModal isModalOpened={isModalOpened} onModalClose={onModalClose} onAfterSubmit={onAfterSubmit} selectedCustomer={selectedCustomer} />
		</>
	);
};